var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1238_231)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M51 36C60.9751 36 69 27.9751 69 18C69 8.02494 60.9751 0 51 0C41.0249 0 33 8.02494 33 18C33 27.9751 41.0249 36 51 36Z",
  fill: "#2775CA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.95 20.8504C55.95 18.2255 54.375 17.3255 51.225 16.9505C48.975 16.6505 48.525 16.0505 48.525 15.0004C48.525 13.9503 49.2751 13.2755 50.775 13.2755C52.125 13.2755 52.8751 13.7255 53.25 14.8505C53.3251 15.0755 53.5501 15.2254 53.7751 15.2254H54.975C55.275 15.2254 55.5 15.0004 55.5 14.7005V14.6255C55.2 12.9754 53.85 11.7005 52.125 11.5505V9.75051C52.125 9.45045 51.9 9.22545 51.5251 9.15039H50.4001C50.1 9.15039 49.875 9.37539 49.8 9.75051V11.4755C47.55 11.7755 46.1251 13.2755 46.1251 15.1505C46.1251 17.6255 47.625 18.6004 50.775 18.9755C52.8751 19.3505 53.5501 19.8005 53.5501 21.0005C53.5501 22.2006 52.5 23.0255 51.0751 23.0255C49.125 23.0255 48.45 22.2004 48.225 21.0754C48.1501 20.7755 47.9251 20.6254 47.7001 20.6254H46.425C46.1251 20.6254 45.9001 20.8504 45.9001 21.1505V21.2255C46.2 23.1004 47.4 24.4504 49.875 24.8255V26.6255C49.875 26.9254 50.1 27.1504 50.475 27.2255H51.6C51.9 27.2255 52.125 27.0005 52.2001 26.6255V24.8255C54.4501 24.4504 55.95 22.8754 55.95 20.8504V20.8504Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.175 28.7249C41.325 26.625 38.3249 20.1 40.5001 14.3249C41.6251 11.1749 44.1001 8.77494 47.175 7.64994C47.4751 7.5 47.625 7.275 47.625 6.89988V5.84994C47.625 5.54988 47.4751 5.32488 47.175 5.25C47.0999 5.25 46.95 5.25 46.8749 5.32488C39.75 7.57488 35.8499 15.15 38.0999 22.2749C39.4499 26.4749 42.675 29.6999 46.8749 31.0499C47.175 31.1999 47.4751 31.0499 47.5499 30.7499C47.625 30.675 47.625 30.5999 47.625 30.45V29.3999C47.625 29.1749 47.4 28.875 47.175 28.7249ZM55.1251 5.32488C54.825 5.17494 54.5249 5.32488 54.4501 5.62494C54.375 5.7 54.375 5.77488 54.375 5.925V6.97494C54.375 7.275 54.6 7.57488 54.825 7.725C60.675 9.82488 63.6751 16.3499 61.4999 22.125C60.3749 25.275 57.8999 27.6749 54.825 28.7999C54.5249 28.9499 54.375 29.1749 54.375 29.55V30.5999C54.375 30.9 54.5249 31.125 54.825 31.1999C54.9001 31.1999 55.05 31.1999 55.1251 31.125C62.25 28.875 66.1501 21.2999 63.9001 14.1749C62.5501 9.89994 59.2499 6.67488 55.1251 5.32488V5.32488Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 18,
  r: 18,
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1_1238_231)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.9975 5.75977L17.8333 6.31763V22.5042L17.9975 22.668L25.511 18.2268L17.9975 5.75977Z",
  fill: "#343434"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.9975 5.75977L10.4839 18.2268L17.9975 22.668V14.8115V5.75977Z",
  fill: "#8C8C8C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.9975 24.0903L17.905 24.2032V29.9691L17.9975 30.2393L25.5156 19.6514L17.9975 24.0903Z",
  fill: "#3C3C3B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.9975 30.2393V24.0903L10.4839 19.6514L17.9975 30.2393Z",
  fill: "#8C8C8C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.9976 22.668L25.511 18.2268L17.9976 14.8115V22.668Z",
  fill: "#141414"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.4839 18.2268L17.9975 22.668V14.8115L10.4839 18.2268Z",
  fill: "#393939"
}));

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1238_231"
}, /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  fill: "white",
  transform: "translate(33)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1_1238_231"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24.48,
  height: 24.48,
  fill: "white",
  transform: "translate(5.75977 5.75977)"
})));

function SvgEthusdc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 36,
    viewBox: "0 0 69 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthusdc);
export default __webpack_public_path__ + "static/media/ethusdc.607ea54fdc2917b1266ea576a221e277.svg";
export { ForwardRef as ReactComponent };